'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { Breadcrumb } from '@sola/ark-skippy/molecules/breadcrumb/breadcrumb.tsx';
import { keys } from '@sola/contentful-model/keys.ts';
import { getArticlePath } from '@sola/contentful-model/lib/article.ts';
import { articlesUrlBase } from '@sola/contentful-model/lib/routes.ts';
import { LOCALES_CODES } from '@sola/contentful-model/lib/types.ts';
import { ArticleResponseDto } from '@sola/schema/lib/contentful.ts';
import { trailingSlash } from '@sola/utils/string.ts';
import { RenderArticle } from './RenderArticle.tsx';
const ArticleInner = t0 => {
  const $ = _c(23);
  const {
    article,
    locale,
    experiments
  } = t0;
  const data = ArticleResponseDto.parse(article);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["skippy"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const path = usePathname();
  const urlBase = data.taxonomyArticleType ? articlesUrlBase[data.taxonomyArticleType as keyof typeof articlesUrlBase] : "#article";
  let t2;
  if ($[1] !== t) {
    t2 = t("skippy:home", "Home");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      title: t2,
      link: "/"
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const breadcrumbs = [t3];
  if (data.taxonomyArticleType === keys.articleTypes.pressRelease) {
    let t4;
    if ($[5] !== t) {
      t4 = t("skippy:pressCenter", "Press Center");
      $[5] = t;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== urlBase) {
      t5 = urlBase.split("/").slice(0, -1).join("/");
      $[7] = urlBase;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t4 || $[10] !== t5) {
      t6 = {
        title: t4,
        link: t5
      };
      $[9] = t4;
      $[10] = t5;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    breadcrumbs.push(t6);
  }
  const t4 = t(`articles:taxonomy.articleTypes.${data.taxonomyArticleType}.pluralName`) || "Article";
  let t5;
  if ($[12] !== t4 || $[13] !== urlBase) {
    t5 = {
      title: t4,
      link: urlBase
    };
    $[12] = t4;
    $[13] = urlBase;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  breadcrumbs.push(t5);
  const t6 = article.pageTitle || "";
  const t7 = trailingSlash(getArticlePath(article.slug, data.taxonomyArticleType));
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = {
      title: t6,
      link: t7
    };
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  breadcrumbs.push(t8);
  let t9;
  if ($[18] !== data || $[19] !== experiments || $[20] !== locale || $[21] !== path) {
    t9 = <main id="main"><RenderArticle article={data} locale={locale} path={path} experiments={experiments} /></main>;
    $[18] = data;
    $[19] = experiments;
    $[20] = locale;
    $[21] = path;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return <><Breadcrumb breadcrumbs={breadcrumbs} />{t9}</>;
};
export const ArticlePage = t0 => {
  const $ = _c(4);
  const {
    article,
    locale,
    experiments
  } = t0;
  let t1;
  if ($[0] !== article || $[1] !== experiments || $[2] !== locale) {
    t1 = <ArticleInner article={article} locale={locale} experiments={experiments} />;
    $[0] = article;
    $[1] = experiments;
    $[2] = locale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};